import { render, staticRenderFns } from "./siteBranch.vue?vue&type=template&id=becab576&"
import script from "./siteBranch.vue?vue&type=script&lang=ts&"
export * from "./siteBranch.vue?vue&type=script&lang=ts&"
import style0 from "./siteBranch.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports